import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If that email exists, a code was sent");
      setStep(2);
    } catch { toast.error("Failed"); } finally { setBusy(false); }
  };
  const reset = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: pw });
      toast.success("Password updated — sign in with your new password");
      setTimeout(() => window.location.assign("/login"), 500);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-8 border-slate-200 shadow-lg">
        <div className="mb-6 flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-700"><KeyRound className="w-5 h-5"/></div>
          <div>
            <h2 className="text-xl font-bold text-slate-900">Reset password</h2>
            <p className="text-xs text-slate-500">{step === 1 ? "Enter your email to get a code" : "Enter the code and your new password"}</p>
          </div>
        </div>
        {step === 1 ? (
          <form onSubmit={sendCode} className="space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required data-testid="forgot-email-input"/></div>
            <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="forgot-send-button">
              {busy ? "Sending…" : "Send code"}
            </Button>
          </form>
        ) : (
          <form onSubmit={reset} className="space-y-4">
            <div><Label>6-digit code</Label><Input value={code} onChange={(e)=>setCode(e.target.value.replace(/\D/g,"").slice(0,6))} required inputMode="numeric" className="text-center tracking-widest font-mono" data-testid="reset-code-input"/></div>
            <div><Label>New password</Label><Input type="password" value={pw} onChange={(e)=>setPw(e.target.value)} required minLength={6} data-testid="reset-password-input"/></div>
            <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="reset-submit-button">
              {busy ? "Updating…" : "Reset password"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 flex items-center gap-1 text-xs text-slate-500 hover:text-slate-700" data-testid="back-to-login">
          <ArrowLeft className="w-3 h-3"/> Back to sign in
        </Link>
      </Card>
    </div>
  );
}
